import { ChangeDetectorRef, Component, ElementRef, HostBinding, HostListener, ViewChild } from '@angular/core';
import { TranslationService } from './i18n/translation.service';
import { locale as enLang } from './i18n/vocabs/en';
import { locale as arLang } from './i18n/vocabs/ar';
import { PlatformService } from './services/platform.service';
import { ResizeService } from './services/resize.service';
import { ScrollService } from './services/scroll.service';
import 'default-passive-events';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SharedService } from './services/shared.service';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { PreviousRouteService } from './services/previous-route.service';
import { logMessage } from './helpers/logs';
import { environment } from 'src/environments/environment';
import { RouteLocalizationPipe } from './pipes/route-localization.pipe';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  isDefaultLayoutEnabled: boolean = true;
  @ViewChild('header') header!: any;
  @ViewChild('footer') footer!: any;
  private lastScrollY = typeof window !== 'undefined' ? window.scrollY : 0;
  @ViewChild('btnSpecialCaseMain') btnSpecialCaseMain!: ElementRef;
  btnSpecialCaseURL: any = {
    url: 'static',
    queryParams: []
  };
  previousRoute: any;
  isMobile: boolean = false;
  @HostBinding('style.--primary-color') primaryColor = '#00904A';
  pageType: string = "qjet";
  isPaddingEnabled: boolean = false;
  private routerEventsSubscription: Subscription;
  lang: string = 'en';

  constructor(
    private translationService: TranslationService,
    public platformService: PlatformService,
    private resizeService: ResizeService,
    private scrollService: ScrollService,
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private location: Location,
    private PreviousRouteService: PreviousRouteService,
    private routeLocalizationPipe: RouteLocalizationPipe,
  ) {
    this.removeUnusedTopUpAmount();
    this.translationService.loadTranslations(enLang, arLang);
    const newURL = this.translationService.setLanguageLanding();

    if (newURL) {
      const urlData = this.parseRelativeURL(newURL);
      this.btnSpecialCaseURL = {
        url: urlData.baseUrl,
        queryParams: urlData.queryParams
      };
      this.setBTNSpecialCase();
    } else {
      this.btnSpecialCaseURL = {
        url: '',
        queryParams: []
      };
    }
    this.routerEventsSubscription = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.handleDashboardLayout();
        this.PreviousRouteService.saveCurrentURL(event?.urlAfterRedirects || '');
        setTimeout(() => {
          // this.checkFooterVisibility();
        });
        // 
        if (!this.isMobile) this.bindConsent();
        this.translationService.setLanguageBackBTN(this.lang);
      }
    });

    this.handleMobilePages();

    if (!this.isMobile) {
      this.resizeService.initializeResizeEvent();
      this.scrollService.initializeScrollEvent();
      this.scrollToTopOnRoute();
      this.updatePageType(this.location.path());
    }
  }


  removeUnusedTopUpAmount(){
    if(typeof window !== 'undefined'){
      const url = this.location.path();
      const topupA = localStorage.getItem('topupA');


      
      

      if(url.endsWith("/checkout") || url.indexOf("/topup-checkout") !== -1 || url.indexOf("/checkout-cyber-topup") !== -1 || url.indexOf("/checkout-qpay-topup") !== -1 || url.indexOf("/checkout-cyber-inspection") !== -1 || url.indexOf("/checkout-qpay-inspection") !== -1) {
        if(!topupA) this.router.navigate([this.routeLocalizationPipe.transform('')])
      } else {
        localStorage.removeItem('topupA');
      }
    }
  }

  // Convert array to object for queryParams binding
  getQueryParams() {
    return this.btnSpecialCaseURL.queryParams.reduce((acc: any, param: any) => {
      acc[param.key] = param.value;
      return acc;
    }, {});
  }

  parseRelativeURL(relativeUrl: string) {
    const dummyDomain = "https://qjet.com";
    const urlObj: any = new URL(relativeUrl, dummyDomain);
    const baseUrl = urlObj.pathname;
    const entries = Array.from(urlObj.searchParams.entries());
    const queryParams = entries.map((item: any) => ({
      key: item?.[0] || '',
      value: item?.[1] || ''
    }));
    return { baseUrl, queryParams };
  }

  getPathAfterLang(url: string): string {
    const match = (url || '').match(/\/(ar|en)\/(.*)/);
    return match ? match[2] : ''; // Return the captured path or an empty string if no match
  }

  isStrContain(str: string, strToCompare: string) {
    return (str || '').indexOf((strToCompare || '')) !== -1;
  }

  bindConsent() {
    const consentEle = typeof window !== 'undefined' ? document.querySelector('[aria-label="cookieconsent"]') : null;

    if (consentEle) consentEle.remove();
    // 
    this.lang = this.translationService.getSelectedLanguage();
    if (typeof window === 'undefined') return;
    const url = window.location.href;
    if (url.indexOf("webview/checkout") == -1 && url.indexOf("webview/save-card") == -1 && url.indexOf("payment-confirm") == -1) {
      const script = document.createElement('script');
      script.src = 'https://cdn-prod.eu.securiti.ai/consent/cookie-consent-sdk-loader.js';
      // 
      script.setAttribute('data-tenant-uuid', 'cd96540e-0fcf-46d5-8c34-74145122363f');
      script.setAttribute('data-domain-uuid', this.lang === 'ar' ? '1ce344d1-a97b-4ea9-9f6f-8d49f39d7d9c' : 'b586db05-518f-4409-bb74-3d84e9b93d2a');//
      script.setAttribute('data-backend-url', 'https://app.eu.securiti.ai');
      script.setAttribute('data-skip-css', 'false');
      script.defer = true;
      // 
      if (this.lang === 'ar') {

        script.addEventListener('load', () => {
          let scriptData: any = {};
          scriptData[this.sharedService.getDomainURL() + '/ar'] = "ar";
          logMessage('consent script', scriptData);
          window.setConsentBannerParams(
            {
              overrideBannerLanguage: scriptData
            })
        });
      }
      // 
      const parentNode = document.head || document.body;
      parentNode.appendChild(script);
    }
  }


  @HostListener('window:scroll', []) onScroll() {
    // this.checkFooterVisibility();
  }

  // checkFooterVisibility() {
  //   let footerElement = this.footer?.footerElement?.nativeElement || null;
  //   const headerElement = this.header?.headerElement?.nativeElement || null;

  //   if (!footerElement || !headerElement) return;
  //   footerElement = footerElement.querySelector("footer");
  //   if (!footerElement) return;

  //   const footerRect = footerElement.getBoundingClientRect();
  //   const footerVisible = (footerRect.top + 200) < window.innerHeight;

  //   const mainEle: any = document.querySelector('#router-outlet');

  //   if (!mainEle) return;

  //   if (mainEle.offsetHeight > 400) {
  //     if (footerVisible) {
  //       headerElement.style.top = "-100%"; // Hide header
  //     } else if (window.scrollY < this.lastScrollY) {
  //       headerElement.style.top = "0"; // Show header on scroll up
  //     }
  //   } else {
  //     headerElement.style.top = "0";
  //   }

  //   this.lastScrollY = window.scrollY;
  // }


  scrollToTopOnRoute() {
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const prevURL = this.previousRoute || '';
        this.previousRoute = this.router.url || '';
        const currentURL = this.previousRoute || '';

        const routesToIgnoreScrolling = [
          {
            from: '/media-center/multimedia/',
            to: '/media-center/multimedia/'
          }
        ];

        const isIgnored = routesToIgnoreScrolling.some((item: any) => prevURL.indexOf(item.from) !== -1 && currentURL.indexOf(item.to) !== -1);

        if (!isIgnored && typeof window !== 'undefined') {
          window.scrollTo({ top: 0 });
        }
      }
    });
  }

  handleMobilePages() {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        const url = window.location.href;
        if (url.indexOf("webview/checkout") !== -1 || url.indexOf("webview/save-card") !== -1) {
          const amount = +this.route.snapshot.queryParams?.amount || 0;
          const token = this.route.snapshot.queryParams?.token || '';
          if(url.indexOf("webpayment=true") === -1) this.isMobile = true;
          if (amount && token) {
            this.sharedService.enableFullLoader();
          }
        } else if (
          (
            (url.indexOf("payment-confirm") !== -1 && localStorage.getItem('mobileToken') && url.indexOf("webpayment=true") === -1) ||
            (url.indexOf("payment-confirm") !== -1 && url.indexOf("webpayment=true") !== -1)
          ) ||
          url.indexOf("webview/cancel-transaction") !== -1 ||
          url.indexOf("webview/payment-failure") !== -1
        ) {
          if(url.indexOf("webpayment=true") === -1) this.isMobile = true;
        }
      });
    }
  }

  ngAfterViewInit(): void {
    if (!this.isMobile) this.scrollTopOnEachRouteChange();
    this.detectAppleDevice();
  }

  scrollTopOnEachRouteChange() {
    if (this.platformService.isClient()) {
      const routerSubscription = this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.updatePageType(event.urlAfterRedirects);
        }
      });
    }
  }

updatePageType(url: string) {
  // Set primary color
  const newColor = "#014A8E";
  if (this.primaryColor !== newColor) {
    this.primaryColor = newColor;
  }

  // ✅ Set favicon based on pageType
  const iconPath = 'assets/images/logos/Qjet_logo_header_colored.png';

  if(typeof window !== 'undefined'){
    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'icon');
      document.head.appendChild(link);
    }
    link.setAttribute('href', iconPath);
  }
}


  detectAppleDevice() {
    if (typeof window === 'undefined') return;
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();

    if (platform.includes('mac')) {
      document.documentElement.classList.add('ios'); // Add a class for macOS
    }

    if (/iphone|ipad|ipod/.test(userAgent)) {
      document.documentElement.classList.add('ios'); // Add a class for iOS devices (iPhones, iPads, iPods)
    }

    if (/macintosh/.test(userAgent) && 'ontouchend' in document) {
      // Detect iPads running desktop-class Safari (iPadOS)
      document.documentElement.classList.add('ios');
    }
  }

  setBTNSpecialCase() {
    setTimeout(() => {
      if (!this.btnSpecialCaseMain?.nativeElement) return;
      this.btnSpecialCaseMain.nativeElement.click();
      setTimeout(() => {
        this.btnSpecialCaseURL = {
          url: '',
          queryParams: []
        };
      });
    });
  }

  ngOnDestroy() {
    // Unsubscribe from router events to prevent memory leaks
    this.routerEventsSubscription.unsubscribe();
  }



  handleDashboardLayout(){
    if (typeof window !== 'undefined'){
      const url = window.location.href;
      const isDahboardPages = url.indexOf("dashboard/") !== -1;
      if(isDahboardPages){
        const isCurrentPageFromTheBelowPages = url.indexOf("dashboard/profile") !== -1 || url.endsWith("/dashboard/wallet");
        this.isDefaultLayoutEnabled = isCurrentPageFromTheBelowPages;
      }else{
        this.isDefaultLayoutEnabled = true;
      }
    }
    // this.cdk.detectChanges();
  }

}
